import React from 'react';
import PropTypes from 'prop-types';

const Filter = ({color = 'currentColor', ...props}) => (
  <svg
    width="18"
    height="12"
    viewBox="0 0 18 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.46154 6H14.5385M1 1H17M7.15385 11H10.8462"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

Filter.propTypes = {
  color: PropTypes.string,
};

export default Filter;
